<bringoz-icon iconName="message"
              fill="#A3A3A3"
              (click)="open(service, $event)">
</bringoz-icon>
